<template>
  <div class="deta">

    <div class="result">

      <template>
        <div class="result_content">
          <div class="result_content_top">
            <div class="result_content_top_img">
              <img src="../../assets/follow/success.png" alt="">
              <p>复诊预约信息</p>
            </div>
            <ul class="result_content_top_ul">
              <li>
                <span>检查时间</span>
                <p>{{ deta.appointDate }}  {{ deta.appointPeriod }}</p>
              </li>
              <li>
                <span>预约地点</span>
                <p>{{ deta.appointHospital }}</p>
              </li>
            </ul>
          </div>

          <p class="result_content_title">复诊原因</p>
          <ul class="result_ul">
            <li class="result_ul_li" v-for="(item,index) in deta.followAdviceList" :key="index">
              <div class="contents">
                <div class="disableds">
                  <span>检查科室:</span>
                  <p>{{ item.deptName }}</p>
                </div>
                <ul class="contents_ul">
                  <li v-for="(items,indexs) in item.adviceList" :key="indexs">
                    <div class="contents disableds">
                      <span>检查原因:</span>
                      <p>{{ items.reason }}</p>
                    </div>
                    <div class="contents disableds">
                      <span>检查结果:</span>
                      <p>{{ items.advice }}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ul>

        </div>
      </template>

    </div>

  </div>
</template>

<script>
export default {
  name: "FollowResult",
  data() {
    return {
      deta: {}
    }
  },
  created() {
    this.get_deta(this.$route.query.id);
  },
  mounted() {

  },
  methods: {
    get_deta(y) {
      this.$get("follow/appointment",y,true)
        .then(res => {
          if(res) {
            console.log(res);
            this.deta= res.data;
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../style/Nav/Follow";
  @import "../../style/Follow/FollowDeta";
</style>
